import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { experience, nav } from '../data/content';
import Section from './Section';
import Rich from './Rich';

export default function Experience() {
  const { t } = useLanguage();

  return (
    <Section id="experience" title={t(nav.experience)}>
      <ol className="divide-y divide-stone-200 border-y border-stone-200">
        {experience.map((item) => (
          <li key={item.period.en} className="grid gap-4 py-8 md:grid-cols-[14rem_1fr] md:gap-10">
            <div>
              <p className="text-xs tabular-nums text-stone-500">{t(item.period)}</p>
              <h3 className="mt-1 text-balance text-lg font-bold tracking-tight">{t(item.company)}</h3>
              <p className="mt-0.5 text-pretty text-sm text-stone-600">{t(item.role)}</p>
            </div>
            <ul className="space-y-2.5">
              {item.points.map((point, i) => (
                <li key={i} className="flex gap-2.5 text-[15px] leading-7 text-stone-700">
                  <span className="text-stone-400" aria-hidden="true">
                    —
                  </span>
                  <span className="text-pretty">
                    <Rich text={t(point)} />
                  </span>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ol>
    </Section>
  );
}
